import React from "react";
import { motion } from "framer-motion";

export function WhyMe({ t }) {
  return (
    <section id="why" className="relative section-pad">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-20">
          <div className="md:col-span-4">
            <div className="flex items-center gap-3 mb-6">
              <span className="inline-block w-8 h-px bg-[#00E5FF]" />
              <span className="eyebrow">{t.why.eyebrow}</span>
            </div>
            <h2
              className="text-white font-semibold leading-[1.05] tracking-tight"
              style={{
                fontFamily: "'Outfit', sans-serif",
                fontSize: "clamp(30px, 4.5vw, 52px)",
              }}
            >
              {t.why.heading}
            </h2>
          </div>

          <div className="md:col-span-8">
            <ul className="space-y-10 md:space-y-12">
              {t.why.items.map((it, i) => (
                <motion.li
                  key={i}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: "-60px" }}
                  transition={{ duration: 0.55, delay: i * 0.06, ease: "easeOut" }}
                  className="flex gap-6 md:gap-10 border-b border-white/10 pb-8"
                >
                  <div
                    className="text-[#00E5FF] font-bold leading-none shrink-0"
                    style={{ fontFamily: "'Outfit', sans-serif", fontSize: "44px" }}
                  >
                    0{i + 1}
                  </div>
                  <div>
                    <h3
                      className="text-white font-semibold"
                      style={{ fontFamily: "'Outfit', sans-serif", fontSize: "22px" }}
                    >
                      {it.title}
                    </h3>
                    <p
                      className="mt-3 text-[#9BA1A6] leading-relaxed"
                      style={{ fontFamily: "'Manrope', sans-serif", fontSize: "16px" }}
                    >
                      {it.body}
                    </p>
                  </div>
                </motion.li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
